import * as apiMode from './apiMode';
import * as TagApiMock from './mock/TagApi.mock';
import * as TagApiProd from './prod/TagApi.prod';
import * as PaginaApiMock from './mock/PaginaApi.mock';
import * as PaginaApiProd from './prod/PaginaApi.prod';
import * as ContenidoApiMock from './mock/ContenidoApi.mock';   
import * as ContenidoApiProd from './prod/ContenidoApi.prod';  
import * as TipoContenidoApiMock from './mock/TipoContenidoApi.mock';
import * as TipoContenidoApiProd from './prod/TipoContenidoApi.prod';
import * as FormularioApiMock from './mock/FormularioApi.mock';   
import * as FormularioApiProd from './prod/FormularioApi.prod';  
import * as PreguntaRespuestaApiMock from './mock/PreguntaRespuestaApi.mock';   
import * as PreguntaRespuestaApiProd from './prod/PreguntaRespuestaApi.prod';  
import * as ModuloApiMock from './mock/ModuloApi.mock';   
import * as ModuloApiProd from './prod/ModuloApi.prod';  
import * as CursoApiMock from './mock/CursoApi.mock';   
import * as CursoApiProd from './prod/CursoApi.prod';             
import * as UsuarioApiMock from './mock/UsuarioApi.mock';  
import * as UsuarioApiProd from './prod/UsuarioApi.prod';  
import * as RoleApiMock from './mock/RoleApi.mock';   
import * as RoleApiProd from './prod/RoleApi.prod';
import * as InfoApiMock from './mock/InfoApi.mock';   
import * as InfoApiProd from './prod/InfoApi.prod';  
import * as PreguntaApiMock from './mock/PreguntaApi.mock';   
import * as PreguntaApiProd from './prod/PreguntaApi.prod';  
import * as RespuestaApiMock from './mock/RespuestaApi.mock';   
import * as RespuestaApiProd from './prod/RespuestaApi.prod';  
import * as InsigniaApiMock from './mock/InsigniaApi.mock';   
import * as InsigniaApiProd from './prod/InsigniaApi.prod';  
import * as HomecatApiMock from './mock/HomecatApi.mock';   
import * as HomecatApiProd from './prod/HomecatApi.prod'; 
import * as MenuApiMock from './mock/MenuApi.mock';   
import * as MenuApiProd from './prod/MenuApi.prod'; 
import * as ResultadoExamenApiMock from './mock/ResultadoExamenApi.mock';   
import * as ResultadoExamenApiProd from './prod/ResultadoExamenApi.prod';  
import * as PreguntasFrecuentesApiMock from './mock/PreguntasFrecuentesApi.mock';   
import * as PreguntasFrecuentesApiProd from './prod/PreguntasFrecuentesApi.prod';  
import * as ComentariosApiMock from './mock/ComentariosApi.mock';   
import * as ComentariosApiProd from './prod/ComentariosApi.prod'; 
import * as CursoAprendizajeApiMock from './mock/CursoAprendizajeApi.mock';   
import * as CursoAprendizajeApiProd from './prod/CursoAprendizajeApi.prod';  
import * as InscripcionApiMock from './mock/InscripcionApi.mock';   
import * as InscripcionApiProd from './prod/InscripcionApi.prod';  
import * as FinSessionApiMock from './mock/FinSessionApi.mock';   
import * as FinSessionApiProd from './prod/FinSessionApi.prod';  
import * as CursoOpinionApiMock from './mock/CursoOpinionApi.mock';   
import * as CursoOpinionApiProd from './prod/CursoOpinionApi.prod';  
import * as CursoConstanciaApiMock from './mock/CursoConstanciaApi.mock';   
import * as CursoConstanciaApiProd from './prod/CursoConstanciaApi.prod';  
import * as PagosApiMock from './mock/PagosApi.mock';   
import * as PagosApiProd from './prod/PagosApi.prod';  
import * as ReferenciaBancariaApiMock from './mock/ReferenciaBancariaApi.mock';   
import * as ReferenciaBancariaApiProd from './prod/ReferenciaBancariaApi.prod';  
import * as TipoMonedaApiMock from './mock/TipoMonedaApi.mock';   
import * as TipoMonedaApiProd from './prod/TipoMonedaApi.prod';  
import * as CursoTipoMonedaApiMock from './mock/CursoTipoMonedaApi.mock';   
import * as CursoTipoMonedaApiProd from './prod/CursoTipoMonedaApi.prod';  
import * as CrucigramaApiMock from './mock/CrucigramaApi.mock';   
import * as CrucigramaApiProd from './prod/CrucigramaApi.prod';  
import * as CrucigramaPalabrasApiMock from './mock/CrucigramaPalabrasApi.mock';   
import * as CrucigramaPalabrasApiProd from './prod/CrucigramaPalabrasApi.prod';  
import * as UsuarioCursoApiMock from './mock/UsuarioCursoApi.mock';   
import * as UsuarioCursoApiProd from './prod/UsuarioCursoApi.prod'; 
import * as CorreoApiMock from './mock/CorreoApi.mock';   
import * as CorreoApiProd from './prod/CorreoApi.prod'; 
import * as ContableCuentaApiMock from './mock/ContableCuentaApi.mock';   
import * as ContableCuentaApiProd from './prod/ContableCuentaApi.prod';  
import * as ContableGastoApiMock from './mock/ContableGastoApi.mock';   
import * as ContableGastoApiProd from './prod/ContableGastoApi.prod';  
import * as ContableRegistroGastoApiMock from './mock/ContableRegistroGastoApi.mock';   
import * as ContableRegistroGastoApiProd from './prod/ContableRegistroGastoApi.prod';  
import * as CiudadApiMock from './mock/CiudadApi.mock';   
import * as CiudadApiProd from './prod/CiudadApi.prod';   
import * as PaisApiMock from './mock/PaisApi.mock';   
import * as PaisApiProd from './prod/PaisApi.prod'; 
import * as RegionApiMock from './mock/RegionApi.mock';   
import * as RegionApiProd from './prod/RegionApi.prod';  
import * as DescuentoApiMock from './mock/DescuentoApi.mock';   
import * as DescuentoApiProd from './prod/DescuentoApi.prod';  
import * as ConstanciaExternaApiMock from './mock/ConstanciaExternaApi.mock';  
import * as ConstanciaExternaApiProd from './prod/ConstanciaExternaApi.prod'; 

    

export const Api = () => {
    if (apiMode.ENTORNO === 'production') {
        return {
            "TagApi": TagApiProd.TagApi,
            "ModuloApi":ModuloApiProd.ModuloApi, 
            "TipoContenidoApi": TipoContenidoApiProd.TipoContenidoApi,
            "PaginaApi": PaginaApiProd.PaginaApi,
            "ContenidoApi":ContenidoApiProd.ContenidoApi,
            "FormularioApi":FormularioApiProd.FormularioApi,
            "PreguntaRespuestaApi":PreguntaRespuestaApiProd.PreguntaRespuestaApi,
            "ContenidoApi":ContenidoApiProd.ContenidoApi,
            "CursoApi":CursoApiProd.CursoApi,
            "UsuarioApi":UsuarioApiProd.UsuarioApi,
            "RoleApi":RoleApiProd.RoleApi,
            "InfoApi":InfoApiProd.InfoApi,
            "PreguntaApi":PreguntaApiProd.PreguntaApi,     
            "RespuestaApi":RespuestaApiProd.RespuestaApi,
            "InsigniaApi":InsigniaApiProd.InsigniaApi,
            "MenuApi":MenuApiProd.MenuApi,
            "PreguntasFrecuentesApi":PreguntasFrecuentesApiProd.PreguntasFrecuentesApi,
            "HomecatApi":HomecatApiProd.HomecatApi,
            "ResultadoExamenApi":ResultadoExamenApiProd.ResultadoExamenApi,
            "ComentariosApi":ComentariosApiProd.ComentariosApi, 
            "CursoAprendizajeApi":CursoAprendizajeApiProd.CursoAprendizajeApi,
            "InscripcionApi":InscripcionApiProd.InscripcionApi,
            "FinSessionApi":FinSessionApiProd.FinSessionApi,
            "CursoConstanciaApi":CursoConstanciaApiProd.CursoConstanciaApi,
            "CursoOpinionApi":CursoOpinionApiProd.CursoOpinionApi,
            "PagosApi":PagosApiProd.PagosApi,
            "ReferenciaBancariaApi":ReferenciaBancariaApiProd.ReferenciaBancariaApi,
            "TipoMonedaApi":TipoMonedaApiProd.TipoMonedaApi,
            "CursoTipoMonedaApi":CursoTipoMonedaApiProd.CursoTipoMonedaApi,
            "CrucigramaApi":CrucigramaApiProd.CrucigramaApi,     
            "CrucigramaPalabrasApi":CrucigramaPalabrasApiProd.CrucigramaPalabrasApi, 
            "UsuarioCursoApi":UsuarioCursoApiProd.UsuarioCursoApi,
            "CorreoApi":CorreoApiProd.CorreoApi,
            "ContableCuentaApi":ContableCuentaApiProd.ContableCuentaApi,     
            "ContableGastoApi":ContableGastoApiProd.ContableGastoApi,     
            "ContableRegistroGastoApi":ContableRegistroGastoApiProd.ContableRegistroGastoApi,
            "CiudadApi":CiudadApiProd.CiudadApi,     
            "PaisApi":PaisApiProd.PaisApi,     
            "RegionApi":RegionApiProd.RegionApi,
            "DescuentoApi":DescuentoApiProd.DescuentoApi,    
            "ConstanciaExternaApi":ConstanciaExternaApiProd.ConstanciaExternaApi

        }
        
    } else if (apiMode.ENTORNO === 'mock') {
        return {
            "TagApi": TagApiMock.TagApi,
            "ModuloApi":ModuloApiMock.ModuloApi,
            "TipoContenidoApi": TipoContenidoApiMock.TipoContenidoApi,
            "PaginaApi": PaginaApiMock.PaginaApi,
            "ContenidoApi":ContenidoApiMock.ContenidoApi,
            "FormularioApi":FormularioApiMock.FormularioApi,
            "PreguntaRespuestaApi":PreguntaRespuestaApiMock.PreguntaRespuestaApi,
            "CursoApi":CursoApiMock.CursoApi,
            "UsuarioApi":UsuarioApiMock.UsuarioApi,
            "RoleApi":RoleApiMock.RoleApi,
            "InfoApi":InfoApiMock.InfoApi,
            "PreguntaApi":PreguntaApiMock.PreguntaApi,
            "RespuestaApi":RespuestaApiMock.RespuestaApi,
            "InsigniaApi":InsigniaApiMock.InsigniaApi,
            "MenuApi":MenuApiMock.MenuApi,
            "PreguntasFrecuentesApi":PreguntasFrecuentesApiMock.PreguntasFrecuentesApi,
            "HomecatApi":HomecatApiMock.HomecatApi,
            "ResultadoExamenApi":ResultadoExamenApiMock.ResultadoExamenApi,
            "ComentariosApi":ComentariosApiMock.ComentariosApi,
            "CursoAprendizajeApi":CursoAprendizajeApiMock.CursoAprendizajeApi,
            "InscripcionApi":InscripcionApiMock.InscripcionApi,
            "FinSessionApi":FinSessionApiMock.FinSessionApi,
            "CursoConstanciaApi":CursoConstanciaApiMock.CursoConstanciaApi,
            "CursoOpinionApi":CursoOpinionApiMock.CursoOpinionApi,
            "PagosApi":PagosApiMock.PagosApi,
            "ReferenciaBancariaApi":ReferenciaBancariaApiMock.ReferenciaBancariaApi,
            "TipoMonedaApi":TipoMonedaApiMock.TipoMonedaApi,
            "CursoTipoMonedaApi":CursoTipoMonedaApiMock.CursoTipoMonedaApi,
            "CrucigramaApi":CrucigramaApiMock.CrucigramaApi,
            "CrucigramaPalabrasApi":CrucigramaPalabrasApiMock.CrucigramaPalabrasApi,
            "UsuarioCursoApi":UsuarioCursoApiMock.UsuarioCursoApi,
            "CorreoApi":CorreoApiMock.CorreoApi,
            "ContableCuentaApi":ContableCuentaApiMock.ContableCuentaApi,
            "ContableGastoApi":ContableGastoApiMock.ContableGastoApi,
            "ContableRegistroGastoApi":ContableRegistroGastoApiMock.ContableRegistroGastoApi,
            "CiudadApi":CiudadApiMock.CiudadApi,
            "PaisApi":PaisApiMock.PaisApi,
            "RegionApi":RegionApiMock.RegionApi,
            "DescuentoApi":DescuentoApiMock.DescuentoApi,
            "ConstanciaExternaApi":ConstanciaExternaApiMock.ConstanciaExternaApi

        }
    }
}
